export const STRAPI_URL: string =
  import.meta.env.VITE_STRAPI_URL ?? "http://localhost:1337";

export const APP_INSIGHTS_CONNECTION_STRING = import.meta.env
  .VITE_APP_INSIGHTS_CONNECTION_STRING;
